import React from "react";
import { useGetProjectsQuery } from "../../features/project/projectsApi";
import ProjectItem from "./ProjectItem";

export default function ProjectList() {
  const { data: projects, isLoading, isError } = useGetProjectsQuery();

  let projectList;
  if (isLoading) {
    projectList = <div>Loading...</div>;
  } else if (isError) {
    projectList = <div>Error!</div>;
  } else {
    projectList = projects.map((project) => (
      <ProjectItem key={project.id} project={project} />
    ));
  }

  return (
    <div>
      <h3 className="text-xl font-bold">Projects</h3>
      <div className="mt-3 space-y-4">{projectList}</div>
    </div>
  );
}
